// NOTE: expects utagClick function from shared/analytics partial
const trackClick = (opts) => utagClick({ ...opts });

export default trackClick;
